<template>
  <div id="article">
    <div class="home-head">
      <head-common></head-common>
    </div>
    <div class="article-details-components">
      <article-details-person :article="articleParam"></article-details-person>
    </div>
    <div class="home-footer">
      <footer-common></footer-common>
    </div>
  </div>
</template>

<script>
  import HeadCommon from './../HeadCommon.vue'
  import FooterCommon from "./../FooterCommon";
  import ArticleDetailsPerson from "./ArticleDetailsPerson";

  export default {
    name: "ArticleDetailsPage",
    data: function () {
      return {
        articleParam: {
          title: "My wife Wu LingFeng",
          cover: "./../../../static/pic/article-details.jpg",
          content: "Sincerely welcome my wife Wu Lingfeng! " +
            "If you see this page, my first web server is successfully working. I will decorate the zone for love. " +
            "This is the simple version of the zone. In the future, it will display the more abundant content. " +
            "I wish that you could visit the zone often. I love you. May we love each other until the end of time."
        },
      }
    },
    methods: {
    },
    components: {
      ArticleDetailsPerson,
      FooterCommon,
      HeadCommon
    }
  }
</script>

<style scoped>
  div, img, ul, li, p, label, input{margin: 0 auto; padding: 0; border: 0;}
  #article {
    width: 1000px;
    border-style: dotted;
    border-color: aqua;
    background: rgba(204, 204, 204, 0.44);
  }
  #article .article-details-components {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  #article .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/hpage/ArticleDetailsPage.vue